import { render, staticRenderFns } from "./MandateSuspension.vue?vue&type=template&id=63a02eca&scoped=true&"
import script from "./MandateSuspension.vue?vue&type=script&lang=js&"
export * from "./MandateSuspension.vue?vue&type=script&lang=js&"
import style0 from "./MandateSuspension.vue?vue&type=style&index=0&id=63a02eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a02eca",
  null
  
)

export default component.exports